
import { Paper, Stack, Typography } from '@mui/material'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'

const StyledPaper = styled(Paper)(({ theme }) => ({
    borderRadius: 2,
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2)
    }
}))

const TitlePaper = ({ children, title, subtitle, ...props }) => {
    return (
        <StyledPaper elevation={0} {...props}>
            <Stack marginBottom={3}>
                <Typography variant='h6' fontWeight='bold'>
                    {title}
                </Typography>
                <Typography variant='body2'>
                    {subtitle}
                </Typography>
            </Stack>
            {children}
        </StyledPaper>
    )
}

TitlePaper.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired
}

export default TitlePaper